(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Par_Formula_v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-par-gallery]';

    function initialize(root) {
      if (root.dataset.parGalleryReady === 'true') return;

      root.dataset.parGalleryReady = 'true';

      const track = root.querySelector('[data-par-track]');
      const slides = Array.from(root.querySelectorAll('[data-par-slide]'));
      const tabs = Array.from(root.querySelectorAll('[data-par-tab]'));
      const dots = Array.from(root.querySelectorAll('[data-par-dot]'));
      const mobileQuery = window.matchMedia('(max-width: 767px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoRotate = root.dataset.autoRotate === 'true';
      const interval = Number(root.dataset.interval) || 6000;

      let activeIndex = 0;
      let timer = null;
      let scrollTimer = null;
      let visible = true;
      let pressed = false;

      function setAccessibility() {
        slides.forEach((slide, index) => {
          if (mobileQuery.matches) {
            slide.removeAttribute('inert');
            slide.setAttribute('aria-hidden', 'false');
          } else {
            const active = index === activeIndex;
            slide.toggleAttribute('inert', !active);
            slide.setAttribute('aria-hidden', String(!active));
          }
        });
      }

      function setActive(index, options = {}) {
        if (!slides.length) return;

        activeIndex = (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === activeIndex);
        });

        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === activeIndex;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
        });

        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });

        setAccessibility();

        if (options.scroll && track && slides[activeIndex]) {
          track.scrollTo({
            left: slides[activeIndex].offsetLeft,
            behavior: reducedMotion.matches ? 'auto' : 'smooth'
          });
        }
      }

      function stopRotation() {
        window.clearInterval(timer);
        timer = null;
      }

      function startRotation() {
        stopRotation();

        if (
          !autoRotate ||
          reducedMotion.matches ||
          !visible ||
          pressed ||
          slides.length < 2
        ) {
          return;
        }

        timer = window.setInterval(() => {
          setActive(activeIndex + 1, {
            scroll: mobileQuery.matches
          });
        }, interval);
      }

      tabs.forEach((tab) => {
        const activate = () => {
          setActive(Number(tab.dataset.parTab));
          startRotation();
        };

        tab.addEventListener('mouseenter', activate);
        tab.addEventListener('focus', activate);
        tab.addEventListener('click', activate);
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          setActive(Number(dot.dataset.parDot), {
            scroll: true
          });
          startRotation();
        });
      });

      if (track) {
        track.addEventListener(
          'scroll',
          () => {
            if (!mobileQuery.matches) return;

            window.clearTimeout(scrollTimer);

            scrollTimer = window.setTimeout(() => {
              const nextIndex = Math.round(track.scrollLeft / track.clientWidth);

              if (nextIndex !== activeIndex) {
                setActive(nextIndex);
              }

              startRotation();
            }, 100);
          },
          {
            passive: true
          }
        );

        track.addEventListener('pointerdown', () => {
          pressed = true;
          stopRotation();
        });

        ['pointerup', 'pointercancel', 'pointerleave'].forEach((eventName) => {
          track.addEventListener(eventName, () => {
            pressed = false;
            startRotation();
          });
        });
      }

      root.addEventListener('mouseenter', () => {
        if (!mobileQuery.matches) {
          pressed = true;
          stopRotation();
        }
      });

      root.addEventListener('mouseleave', () => {
        if (!mobileQuery.matches) {
          pressed = false;
          startRotation();
        }
      });

      const observer = new IntersectionObserver(
        (entries) => {
          visible = entries[0]?.isIntersecting ?? true;

          if (visible) {
            startRotation();
          } else {
            stopRotation();
          }
        },
        {
          threshold: 0.2
        }
      );

      observer.observe(root);

      mobileQuery.addEventListener('change', () => {
        setActive(activeIndex, {
          scroll: mobileQuery.matches
        });
        startRotation();
      });

      reducedMotion.addEventListener('change', startRotation);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopRotation();
        } else {
          startRotation();
        }
      });

      setActive(0);
      startRotation();
    }

    function initializeAll(scope = document) {
      scope.querySelectorAll(rootSelector).forEach(initialize);
    }

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ochre_par_formula_video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-par-video-showcase]';

    function initialize(root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const carousel = root.querySelector('[data-mobile-carousel]');
      const slides = Array.from(root.querySelectorAll('[data-mobile-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-par-dot]'));
      const tabs = Array.from(root.querySelectorAll('[data-par-tab]'));
      const desktopVideos = Array.from(root.querySelectorAll('[data-desktop-video]'));
      const desktopContent = Array.from(root.querySelectorAll('[data-desktop-content]'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobileQuery = window.matchMedia('(max-width: 767px)');
      const interval = Number(root.dataset.interval) || 6000;
      const canRotate = root.dataset.autoRotate === 'true';
      let activeIndex = 0;
      let timer = null;
      let scrollTimer = null;
      let isPressed = false;

      function playActiveVideos(index) {
        root.querySelectorAll('video').forEach((video) => {
          const holder = video.closest('[data-desktop-video], [data-mobile-slide]');
          const holderIndex = Number(holder?.dataset.desktopVideo ?? holder?.dataset.mobileSlide);

          if (holderIndex === index) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      function setActive(index, options = {}) {
        if (!slides.length && !desktopVideos.length) return;
        const total = Math.max(slides.length, desktopVideos.length);
        activeIndex = (index + total) % total;

        desktopVideos.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === activeIndex);
        });

        desktopContent.forEach((item, itemIndex) => {
          const active = itemIndex === activeIndex;
          item.classList.toggle('is-active', active);
          item.hidden = !active;
        });

        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === activeIndex;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
        });

        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });

        if (options.scrollMobile && carousel && slides[activeIndex]) {
          carousel.scrollTo({
            left: slides[activeIndex].offsetLeft,
            behavior: reduceMotion.matches ? 'auto' : 'smooth'
          });
        }

        playActiveVideos(activeIndex);
      }

      function stopRotation() {
        window.clearInterval(timer);
        timer = null;
      }

      function startRotation() {
        stopRotation();
        if (!canRotate || reduceMotion.matches || slides.length < 2 || isPressed) return;

        timer = window.setInterval(() => {
          setActive(activeIndex + 1, { scrollMobile: mobileQuery.matches });
        }, interval);
      }

      tabs.forEach((tab) => {
        const activate = () => {
          setActive(Number(tab.dataset.parTab));
          startRotation();
        };

        tab.addEventListener('mouseenter', activate);
        tab.addEventListener('focus', activate);
        tab.addEventListener('click', activate);
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          setActive(Number(dot.dataset.parDot), { scrollMobile: true });
          startRotation();
        });
      });

      if (carousel) {
        carousel.addEventListener('scroll', () => {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(() => {
            const index = Math.round(carousel.scrollLeft / carousel.clientWidth);
            if (index !== activeIndex) setActive(index);
            startRotation();
          }, 100);
        }, { passive: true });

        carousel.addEventListener('pointerdown', () => {
          isPressed = true;
          stopRotation();
        });

        ['pointerup', 'pointercancel', 'pointerleave'].forEach((eventName) => {
          carousel.addEventListener(eventName, () => {
            isPressed = false;
            startRotation();
          });
        });
      }

      root.addEventListener('mouseenter', () => {
        if (!mobileQuery.matches) stopRotation();
      });

      root.addEventListener('mouseleave', () => {
        if (!mobileQuery.matches) startRotation();
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopRotation();
        else startRotation();
      });

      const updateParallax = () => {
        if (mobileQuery.matches || reduceMotion.matches) {
          root.style.setProperty('--par-video-shift', '-6%');
          return;
        }

        const rect = root.getBoundingClientRect();
        const progress = Math.max(-1, Math.min(1, (window.innerHeight / 2 - (rect.top + rect.height / 2)) / window.innerHeight));
        const strength = Number(root.dataset.parallax) || 0;
        root.style.setProperty('--par-video-shift', `${-6 + progress * strength * 0.25}%`);
      };

      let parallaxFrame = null;
      window.addEventListener('scroll', () => {
        if (parallaxFrame) return;
        parallaxFrame = window.requestAnimationFrame(() => {
          updateParallax();
          parallaxFrame = null;
        });
      }, { passive: true });

      mobileQuery.addEventListener('change', () => {
        setActive(activeIndex, { scrollMobile: mobileQuery.matches });
        updateParallax();
        startRotation();
      });

      reduceMotion.addEventListener('change', startRotation);
      setActive(0);
      updateParallax();
      startRotation();
    }

    function initializeAll(scope = document) {
      scope.querySelectorAll(selector).forEach(initialize);
    }

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
